import { atom } from '@reatom/framework'
import { useAtom } from '@reatom/npm-react'
import { useEffect, useRef } from 'react'
import { useClickAway } from 'react-use'
import styled from 'styled-components'

import { FavoritesTable } from '@root/features/favorite-pairs/ui/desktop/favorite-pairs-table/favorites-table'
import {
  closeFavoriteDrawerEvent,
  openFavoriteDrawerEvent,
} from '@root/features/services/favorite-pair'
import { reactRootElement } from '@root/shared/ui'
import { DtDrawer } from '@root/shared/ui-kit'

import type { ClassNameProps } from '@root/shared/react'

export const favoriteDrawerOpenAtom = atom(false, 'favoriteDrawerOpenAtom')

type FavoritesDrawerProps = {} & ClassNameProps

export const FavoritesDrawer: React.FC<FavoritesDrawerProps> = ({
  className,
}) => {
  const [open, setOpen] = useAtom(favoriteDrawerOpenAtom)
  const contentRef = useRef<HTMLDivElement>(null)

  useEffect(
    () => openFavoriteDrawerEvent.onCall(() => setOpen(true)),
    [setOpen],
  )
  useEffect(
    () => closeFavoriteDrawerEvent.onCall(() => setOpen(false)),
    [setOpen],
  )

  useClickAway(contentRef, (e) => {
    // Do not close when clicked inside modals
    if (!reactRootElement.contains(e.target as Node)) {
      return
    }
    setTimeout(() => {
      if (open) {
        setOpen(false)
      }
    }, 300)
  })

  return (
    <Root
      className={className}
      onOpenChange={setOpen}
      open={open}
      overlay
      side="left"
      contentRef={contentRef}
    >
      <FavoritesTable onClose={() => setOpen(false)} />
    </Root>
  )
}

const Root = styled(DtDrawer)`
  width: 980px;
  background-color: var(--background-1);
`
